var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeS5P2Img2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_277",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.38623,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 35.5258L8.69384 29.1327V19.1326L1.87772 15.3863L20.5 5.23682L39.1223 15.3863V28.8691H35.4801V17.389L32.3062 19.1326V29.1327L20.5 35.5258ZM20.5 21.3536L31.548 15.3863L20.5 9.4189L9.45201 15.3863L20.5 21.3536ZM20.5 31.3854L28.664 26.975V21.062L20.5 25.5357L12.336 21.062V26.975L20.5 31.3854Z",
    fill: "#B84031"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeS5P2Img2);
export default __webpack_public_path__ + "static/media/HomeS5P2Img2.8d2a96ca20d563593c69b778e2c2afff.svg";
export { ForwardRef as ReactComponent };